import HtzLink from './HtzLink';

export * from './HtzLink';
export default HtzLink;
